// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1Kvss","overflowing":"ReadFullNote_overflowing__1ghYh"};